var graphQLAware = function graphQLAware() {
  return function (graphQL) {
    return function (context) {
      return graphQL(context).then(function (result) {
        if (result.errors) {
          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject({
            graphQLErrors: result.errors,
            data: result.data
          });
        }
        return result;
      });
    };
  };
};

export { graphQLAware };
